import React, { useEffect, useState } from "react"; //FB 7442
import PropTypes from "prop-types";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import { Grid, ThemeProvider, Dialog, DialogContent, CircularProgress, useTheme } from "@mui/material"; //FB 6997
import Box from "@mui/material/Box";
import NavBar from "../../../../components/Navbar";
import UpcomingAppointments from "./upcomingAppointments";
import PastAppointments from "./pastAppointments";
import CancelledAppointments from "./cancelledAppointments";
import useStyles from "../../../../css/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { GetAdminSettingValue } from "../../../../api"; //FB 7442

// Update log
// FB  6192   02/06/2023  DK  Added page to inoke the appointment components
// FB  7442   09/21/2023  DK  Please add message to cancel appointment
// FB  6997   10/09/2023  SK   Patient Portal: All the api's that shows results in the Patient portal needs fine tuning
// FB  8584   05/14/2024  SK  Portal Loading takes long for multiple tabs

function TabPanel(props: any) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`wrapped-tabpanel-${index}`}
      aria-labelledby={`wrapped-tab-${index}`}
      {...other}
    >
      {value === index && <Box p={3}>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index: any) {
  return {
    id: `wrapped-tab-${index}`,
    "aria-controls": `wrapped-tabpanel-${index}`,
  };
}

export default function Appointments() {
  const matches = useMediaQuery("(min-width:600px)");
  const styles = useStyles();
  const [value, setValue] = React.useState("one");
  const [cancellationMessage, setCancellationMessage] = useState(""); //FB 7442

  const handleChange = (event: any, newValue: any) => {
    setValue(newValue);
  };

  // FB 7442 - Start
  async function GetCancelAppointmentMessage() {
    let message = await GetAdminSettingValue("PortalAppointmentCancellationMessage");
    if (message != undefined && message != "" && message != null) {
      setCancellationMessage(message);
      sessionStorage.setItem("AppointmentCancellationMessage", message);
    }
  }

  //FB 6997 - Begin
  const [showSpinner, setShowSpinner] = useState(false);
  const theme = useTheme();
  //FB 6997 - End

  useEffect(() => {
    setShowSpinner(true);//FB 6997
    let message = sessionStorage.getItem("AppointmentCancellationMessage");
    if (message != null) {
      setCancellationMessage(message);
    } else {
      GetCancelAppointmentMessage();
    }
    //FB 6997 - Begin
    setTimeout(() => {
      setShowSpinner(false);
    }, 3000);
    //FB 8584
    //FB 6997 - End
  }, []);
  // FB 7442 - End

  return (
    <>
      {matches && <NavBar />}

      <Box
        sx={
          matches == false
            ? {
              width: "100%",
              paddingLeft: "16px",
              paddingTop: "16px",
              backgroundColor: "#F5F5F5",
              minHeight: "70vh",
            }
            : {
              width: "100%",
              paddingLeft: "80px",
              marginTop: "24px",
              backgroundColor: "#F5F5F5",
              minHeight: "70vh",
            }
        }
      >
        {!matches && (
          <div
            className="row"
            style={{
              paddingLeft: "10px",
              backgroundColor: "#F5F5F5",
              fontWeight: "bold",
            }}
          >
            Appointments{" "}
            <hr
              style={{
                height: "2px",
                border: "none",
                backgroundColor: "black",
              }}
            ></hr>
          </div>
        )}
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Typography variant="h6">
              {matches && (
                <b
                  style={{
                    paddingTop: "20px",
                    fontSize: "32px",
                    fontWeight: "700",
                    lineHeight: "40px",
                  }}
                >
                  Appointments{" "}
                </b>
              )}
            </Typography>
          </Grid>
          {/* FB 7442 */}
          <Grid item xs={12}>
            <Typography variant="subtitle1" style={{ paddingTop: "10px" }}>
              {cancellationMessage}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={5}>
            <Tabs
              value={value}
              variant="fullWidth"
              onChange={handleChange}
              style={{
                backgroundColor: "white",
                borderRadius: "25px",
                marginRight: "16px",
              }}
              TabIndicatorProps={{
                style: { display: "none" },
              }}
            >
              <Tab
                value="one"
                label="Upcoming"
                {...a11yProps("one")}
                className={styles.appt_tab}
              />
              <Tab
                value="two"
                label="Past"
                {...a11yProps("two")}
                className={styles.appt_tab}
              />
              <Tab
                value="three"
                label="Cancelled"
                {...a11yProps("three")}
                className={styles.appt_tab}
              />
            </Tabs>
          </Grid>
          <Grid item xs={12} style={{ paddingLeft: "2px" }}>
            <TabPanel value={value} index="one">
              <UpcomingAppointments />
            </TabPanel>
            <TabPanel value={value} index="two">
              <PastAppointments />
            </TabPanel>
            <TabPanel value={value} index="three">
              <CancelledAppointments />
            </TabPanel>
          </Grid>
          {/* FB 6997 - Begin */}
          <ThemeProvider theme={theme}>
            <Dialog open={showSpinner} fullWidth maxWidth={"xs"}>
              <DialogContent
                style={{
                  display: "flex",
                  alignContent: "center",
                  justifyContent: "center",
                }}
              >
                <CircularProgress style={{ color: "#083A4D" }} />
              </DialogContent>
            </Dialog>
          </ThemeProvider>
          {/* FB 6997 - End */}
        </Grid>
      </Box>
    </>
  );
}
